import React from "react";
import { Skeleton } from "antd";
import styled from "styled-components/macro";
import { Content } from "@worcket/common/components/layout";

import Page from "../../components/display/Page";

const SkeletonItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: fadeIn 0.5s ease;
  overflow: hidden;
  padding: 12px 0;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .skeleton-profile {
    width: 100%;
  }
  .ant-skeleton-title {
    margin-top: 0 !important;
  }
  .ant-skeleton-paragraph {
    padding-left: 0;
    margin-top: 0 !important;
    width: 120px;
  }
  .ant-skeleton {
    width: inherit;
  }
`;

const SkeletonList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
`;

const SkeletonHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  ${SkeletonItem}:nth-child(3) {
    width: 100%;
  }
`;

const SkeletonCompanies = () => {
  return (
    <Page>
      <Content>
        <SkeletonHeader>
          <SkeletonItem>
            <Skeleton
              active
              avatar={false}
              title={{ width: 150, rows: 1 }}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={false}
              title={{ width: 150, rows: 1 }}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={false}
              title={{ width: 100, rows: 1 }}
              paragraph={false}
            />
          </SkeletonItem>
        </SkeletonHeader>
        <SkeletonList>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={{ width: 120, rows: 1 }}
              paragraph={{ rows: 1 }}
            />
            <Skeleton
              active
              avatar={false}
              title={{ width: 120, rows: 1 }}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={{ width: 120, rows: 1 }}
              paragraph={{ rows: 1 }}
            />
            <Skeleton
              active
              avatar={false}
              title={{ width: 120, rows: 1 }}
              paragraph={false}
            />
          </SkeletonItem>
          <SkeletonItem>
            <Skeleton
              active
              avatar={{ shape: "square" }}
              title={{ width: 120, rows: 1 }}
              paragraph={{ rows: 1 }}
            />
            <Skeleton
              active
              avatar={false}
              title={{ width: 120, rows: 1 }}
              paragraph={false}
            />
          </SkeletonItem>
        </SkeletonList>
      </Content>
    </Page>
  );
};

export default SkeletonCompanies;
